
import groupBy from 'lodash.groupby'
import mapValues from 'lodash.mapvalues'

const FI_LOCALE_SUFFIX = '___fi-FI'


export function getOtherPageUrl(lang, path, pages) {
  const otherLang = lang === 'en' ? 'fi' : 'en'
  const location = path.endsWith('/') ?  path.slice(0, -1) : path

  if (location in pages) {
    const id = pages[location].id
    const newId = lang === 'fi' ? id.replace(FI_LOCALE_SUFFIX, '') : id + FI_LOCALE_SUFFIX
    const pageValues = Object.keys(pages).map(function(key) {
      return pages[key]
    })
    const otherPage = pageValues.find(page => page.id === newId)
    
    return otherPage ? otherPage.path : `/${otherLang}`
  } else if (location === '/fi' || location === '/en') {
    return `/${otherLang}`
  }

  return path
}


export function getLocalization(contentfulLocalization, locale) {
  if (!contentfulLocalization) {
    return () => ''
  }
  const combineLocalizations = (output, loc) => output.concat(loc.edges)

  const edges = contentfulLocalization instanceof Array ? contentfulLocalization.reduce(combineLocalizations, []) : contentfulLocalization.edges
  const nodes = edges.map(edge => edge.node)
  const groupedNodes = groupBy(nodes, 'node_locale')
  const localization =
    mapValues(groupedNodes, lang => {
      return mapValues(groupBy(lang, 'key'), value => value[0].text)
    })

  return (key, variables) => {
    if (variables) {
      let string = localization[locale][key]
      Object
        .entries(variables)
        .forEach(([key, val]) => {
            string = string.replace(`$${key}`, val)
        })

      return string
    } else {
      return localization[locale][key]
    }
  }
}


export function setLanguage(lang) {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('lang', lang)
  }
}




// WEBPACK FOOTER //
// ./src/localization.js